module.exports = __webpack_public_path__ + "static/media/logo.7a5e7400.svg";